import { EditOutlined } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useTranslate } from "@refinedev/core";
import { EditButtonProps } from "@refinedev/mui";
import { config } from "config";
import React, { useState } from "react";
import { dataProvider } from "rest-data-provider";

/**
 * `<EditButton>` uses uses Material UI {@link https://mui.com/components/buttons/ `<Button>`} component.
 * It uses the {@link https://refine.dev/docs/core/hooks/navigation/useNavigation#edit `edit`} method from {@link https://refine.dev/docs/core/hooks/navigation/useNavigation `useNavigation`} under the hood.
 * It can be useful when redirecting the app to the edit page with the record id route of resource}.
 *
 * @see {@link https://refine.dev/docs/ui-frameworks/mui/components/buttons/edit-button} for more details.
 */
type ExtendedEditButtonProps = EditButtonProps & {
  dataUpdate: (e: any) => void;
};
export const UserBadgeRelationEditBtn: React.FC<ExtendedEditButtonProps> = ({
  resource: resourceNameFromProps,
  recordItemId,
  hideText = false,
  accessControl,
  svgIconProps,
  meta,
  children,
  onClick,
  dataUpdate,
  ...rest
}) => {
  const translate = useTranslate();
  const apiUrl = config().server.api;
  const [open, setOpen] = useState(false);
  const [issueDate, setIssueDate] = useState("");
  const [expirationDate, setExpirationDate] = useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleSave = () => {
    dataProvider(apiUrl)
      .update({
        resource: "user-badge-relation",
        id: recordItemId ?? "",
        variables: {
          expirationDate,
          issueDate,
        },
      })
      .then(() => {
        dataUpdate(true);
      });
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const issueDateChangeHandler = (e: any) => {
    setIssueDate(e.format("YYYY-MM-DD"));
  };
  const expirationDateChangeHandler = (e: any) => {
    setExpirationDate(e.format("YYYY-MM-DD"));
  };
  return (
    <div>
      <Tooltip title="Edit">
        <Button
          onClick={handleClickOpen}
          startIcon={
            !hideText && (
              <EditOutlined sx={{ selfAlign: "center" }} {...svgIconProps} />
            )
          }
        >
          {hideText ? (
            <EditOutlined fontSize="small" {...svgIconProps} />
          ) : (
            children ?? translate("buttons.edit", "Edit")
          )}
        </Button>
      </Tooltip>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit Badges</DialogTitle>
        <DialogContent>
          <DatePicker label="Issue Date" onChange={issueDateChangeHandler} />
          <DatePicker
            label="Expiration Date"
            onChange={expirationDateChangeHandler}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
